import React, { useEffect, useState } from "react";
import Parse from "../../api/ApiConfig";
import { Outlet, useNavigate, useParams } from "react-router";
import AdminDashboardLayout from "../../layout/AdminDashboardLayout";
import { PageHeader } from "./TravelAdvance.styled";
import FilterCategory from "../../components/ReusableComponents/FilterCategory";
import { Backdrop, CircularProgress } from "@mui/material";
import { TabList } from "./data";
import TravelAdvanceTable from "./sections/TravelAdvanceTable";
import { fetchTableData } from "./utils";
import { toast } from "react-toastify";
import { StyledContainer } from "../../globalStyle/GlobalStyle";

/* eslint-disable no-unused-vars */
const TravelAdvance = () => {
	let navigate = useNavigate();
	let { category, id: requestId } = useParams();
	const [currentTab, setCurrentTab] = useState(category || "submitted");
	const [TableData, setTableData] = useState([]);
	const [defaultData, setDefaultData] = useState([]);
	const [loading, setLoading] = useState(false);

	const getTableData = async (category) => {
		const data = await fetchTableData(category || currentTab);
		if (data) {
			setLoading(false);
			setTableData(data);
			setDefaultData(data);
		} else {
			setLoading(false);
			setTableData([]);
			toast.error("Error fetching data!");
		}
	};

	useEffect(() => {
		// If current page is TVA Dashboard, fetch data
		if (!requestId) {
			setLoading(true);
			getTableData();
		}
	}, []);

	useEffect(() => {
		if (category) {
			setCurrentTab(category);
		} else {
			navigate(`/travel-advance/${currentTab}`, { replace: true });
		}
	}, [category]);

	const handleTabChange = (category) => {
		setLoading(true);
		getTableData(category);
		navigate(`/travel-advance/${category}`);
	};

	const handleDeleteItem = async (selected) => {
		if (selected.length) {
			setLoading(true);
			const ParseObjects = selected.map((item) => {
				const ParseObj = new Parse.Object("TravelAdvance");
				ParseObj.id = item.objectId;
				return ParseObj;
			});

			Parse.Object.destroyAll(ParseObjects)
				.then((object) => {
					getTableData();
					toast.success("Travel Advance Item(s) Deleted Successfully");
					console.log("Deleted ParseObjects:", object);
				})
				.catch((error) => {
					setLoading(false);
					console.error(error);
					toast.error("Error deleting Item(s)");
				});
		} else {
			toast.error("No Item selected");
		}
	};

	return (
		<AdminDashboardLayout data={TableData} defaultData={defaultData} setData={setTableData}>
			<StyledContainer>
				<PageHeader>
					<FilterCategory
						currentTab={currentTab}
						tabList={TabList}
						handleClick={(category) => handleTabChange(category)}
					/>
				</PageHeader>

				<>
					{requestId ? (
						<Outlet context={[loading, setLoading]} />
					) : (
						<TravelAdvanceTable
							currentTab={currentTab}
							TableData={TableData}
							handleDeleteItem={handleDeleteItem}
						/>
					)}
				</>
			</StyledContainer>

			{loading && (
				<Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
					<CircularProgress color='inherit' />
				</Backdrop>
			)}
		</AdminDashboardLayout>
	);
};

export default TravelAdvance;
